import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';

import React, { useState } from 'react';
import { connectedAppService } from '../../../../projects/platform/services/connected-app-services';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';


const ConnectedApps = () => {
    const [mainStore] = useState(new CustomStore({
        key: "id",
        load: connectedAppService.getListAsync,
        update: (key, values) => {
            return connectedAppService.updateAsync(`${key}`, values);
        },
        remove: (key) => {
            return connectedAppService.deleteAsync(`${key}`);
        },
        useDefaultSearch: true
    }));

    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    return (

        <React.Fragment>
            <DataGridWrapper
                props={{
                    id: 'connected-app-list', remoteOperations: true,

                    keyExpr: "id"
                }}
                permissonCode='ConnectedApp.ConnectedApp'
                datasource={mainStore}
                pagerVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={false}
                columnChooser={false}
                onRowUpdating={handleRowUpdating}
                editingConfig={{
                    mode: 'batch',
                    allowAdding: false,
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Record'),
                }}
                columns={[
                    {
                        dataField: "id",
                        visible: false
                    },
                    {
                        dataField: 'contactInfo',
                        caption: t('contact_info'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: false
                    },
                    {
                        dataField: 'appType',
                        caption: t('app_type'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: false
                    },
                    {
                        dataField: 'isActive',
                        caption: t('active'),
                        filtering: false,
                        allowSearch: false,
                        dataType: 'boolean',
                        calculateCellValue: (rowData: any) => {
                            return rowData.isActive || false;
                        },
                    },
                ]}
            />
        </React.Fragment>
    )
}
export default ConnectedApps